'use client';
import React from 'react';
import Link from 'next/link';
import { FilePlus, ShieldCheck, Wrench, Search, Mic } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const actions = [
  { label: 'Capture Invoice', icon: FilePlus, href: '/invoice-capture-management', color: 'bg-primary text-primary-foreground', primary: true },
  { label: 'Check Warranty', icon: ShieldCheck, href: '/warranty-locker', color: 'bg-success/10 text-success border border-success/20', primary: false },
  { label: 'Service Request', icon: Wrench, href: '/service-request', color: 'bg-primary/10 text-primary border border-primary/20', primary: false },
  { label: 'Find Provider', icon: Search, href: '/service-request', color: 'bg-muted text-foreground border border-border hover:border-primary/40', primary: false },
  { label: 'Voice Action', icon: Mic, href: '#', color: 'bg-muted text-muted-foreground border border-border', primary: false },
];

export default function DashboardQuickActions() {
  return (
    <div className="flex flex-wrap gap-2">
      {actions?.map((action) => {
        const Icon = action?.icon;
        return (
          <Link
            key={`qa-${action?.label}`}
            href={action?.href}
            className={`inline-flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-500 transition-all duration-150 hover:shadow-card active:scale-95 ${action?.color}`}
          >
            <Icon size={15} />
            <span>{action?.label}</span>
          </Link>
        );
      })}
    </div>
  );
}